"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionOverview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_common_components_1 = require("@desygner/ui-common-components");
const CollectionOverView_style_1 = require("./CollectionOverView.style");
function CollectionOverview({ label, collections, }) {
    return ((0, jsx_runtime_1.jsx)(CollectionOverView_style_1.StyledWrapper, { children: (0, jsx_runtime_1.jsx)(CollectionOverView_style_1.StyledCollectionWrapper, { children: collections.map((item) => ((0, jsx_runtime_1.jsx)(ui_common_components_1.ImageCard, { source: item.imageUrl, title: item.label, details: item, draggable: false, onClick: item.onClick }, `template-card-${item.imageUrl}`))) }) }));
}
exports.CollectionOverview = CollectionOverview;
//# sourceMappingURL=CollectionOverview.js.map